<alaris-card (blur)="onTouched()" class="array-container">
	@for (control of internalArray.controls; track $index) {
		<div class="array-wrapper">
			<div class="array-header">
				@let choiceNumber = $index + 1;
				<ds-form-label [textLabel]="'Choice #' + choiceNumber" [style]="'margin-bottom: 1rem'"></ds-form-label>
				@if (choiceNumber > 1) {
					<ds-icon-swap
						iconName="icon-delete-20"
						(click)="removeItem($index)"
						mode="tertiary"
						form="square"
						size="M"
						style="cursor: pointer"
					></ds-icon-swap>
				}
			</div>

			<div class="array-items">
				<ds-select-dropdown-preset
					[options]="availableSources()"
					[formControl]="control"
					[search]="true"
					class="select-source"
				>
					<ds-select [label]="'ai_rules.source' | translate" [labelAsterisk]="true" slot="trigger"></ds-select>
				</ds-select-dropdown-preset>
			</div>
		</div>
	}
	@if (internalArray.length < maxChoiceCount()) {
		<button
			dsButton
			type="button"
			(click)="addItem()"
			size="M"
			view="ghost-secondary"
			class="add-choice"
			[iconLeftProps]="{ name: 'icon-add-20', form: 'square' }"
		>
			{{ 'ai_rules.add_choice' | translate }}
		</button>
	}
</alaris-card>
